import { render, staticRenderFns } from "./reduceNumber.vue?vue&type=template&id=a380ead2&scoped=true"
import script from "./reduceNumber.vue?vue&type=script&lang=js"
export * from "./reduceNumber.vue?vue&type=script&lang=js"
import style0 from "./reduceNumber.vue?vue&type=style&index=0&id=a380ead2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a380ead2",
  null
  
)

export default component.exports